module.exports = __webpack_public_path__ + "img/007-car.402e5644.png";